import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// @material-ui/core components
import { withStyles } from "tss-react/mui";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import JamezzTable from "../../components/JamezzTable/JamezzTable";
import Button from "../../components/CustomButtons/Button";

import vestigingStyle from "../../assets/jss/material-dashboard-pro-react/views/vestigingStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";
import { DialogContext } from "../../licensing/utils/DialogProvider";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import { Add, Layers, Payment, Refresh, Restaurant } from "@mui/icons-material";
import Debtor from "../../licensing/Models/Debtor";
import Reseller from "../../licensing/Models/Reseller";
import VenueFilter from "../../components/Filters/VenueFilter";
import {
  JamezzTableDateField,
  JamezzTableField,
  JamezzTableLinkToRelation,
} from "../../components/JamezzTable/JamezzTableFields";
import { Link, useNavigate } from "react-router";
import DebtorFilter from "../../components/Filters/DebtorFilter";
import ResellerFilter from "../../components/Filters/ResellerFilter";
import CloseIcon from "@mui/icons-material/Close";
import EndSubscription from "./Dialogs/EndSubscription";
import Subscription from "../../licensing/Models/Subscription";

const SubsSubscriptionsIndex = ({ classes }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openDialog] = useContext(DialogContext);

  const filters = useSelector((state) => {
    let filters = {};
    if (state.filtersV2.subs_debtor_id) {
      filters.subs_debtor_id = state.filtersV2.subs_debtor_id;
    }
    if (state.filtersV2.venue_id) {
      filters.venue_id = state.filtersV2.venue_id;
    }
    if (state.filtersV2.subs_reseller_id) {
      filters.subs_reseller_id = state.filtersV2.subs_reseller_id;
    }
    return filters;
  });

  const setFilter = (key, filter) => {
    dispatch({
      type: actions.SET_FILTER,
      payload: { key, filter },
    });
  };

  const showMessage = (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message });
  const closeMessage = () => dispatch({ type: actions.CLOSE_MESSAGE });

  const [subs_debtors, setSubs_debtors] = useState([]);
  const [subs_resellers, setSubs_resellers] = useState([]);
  const [venues, setVenues] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [copyModal, setCopyModal] = useState(false);
  const [newModal, setNewModal] = useState(false);

  const jamezzTable = useRef();

  useEffect(() => {
    getSubsDebtors();
    getSubsResellers();
  }, []);

  const getSubsDebtors = () => {
    Debtor.index([]).then(({ models }) => {
      setSubs_debtors(models.map((debtor) => ({ ...debtor, label: debtor.company_name, value: debtor.id })));
    });
  };

  const getSubsResellers = () => {
    Reseller.index([]).then(({ models }) => {
      setSubs_resellers(
        models.map((reseller) => ({
          ...reseller,
          label: reseller.description,
          value: reseller.id,
        }))
      );
    });
  };

  const toggleModal = (modal) => {
    if (modal === "copyModal") {
      setCopyModal(!copyModal);
    } else if (modal === "newModal") {
      setNewModal(!newModal);
    }
  };

  const renderStatus = (row) => {
    return "Test";
  };

  const actions = [
    {
      icon: CloseIcon,
      tooltip: <TranslationWrapper tKey={"End license"} />,
      action: (row) => {
        openDialog({ children: <EndSubscription subscriptionId={row[0]} />, fullWidth: true, maxWidth: "lg" });
      },
      show: (row) => {
        return !row[5];
      },
    },
    {
      icon: Layers,
      tooltip: <TranslationWrapper tKey={"Duplicate"} />,
      action: (row) => {
        setFilter("venue_id", null);
        setFilter("vestiging.venue_id", null);
        navigate("/manager/subssubscriptions/create?duplicateFromId=" + row[0]);
      },
    },
  ];

  if (import.meta.env.MODE !== "production") {
    actions.push({
      icon: Payment,
      tooltip: <TranslationWrapper tKey={"Charge"} />,
      action: (row) => {
        Subscription.makeInvoice(row[0]).then(() => {
          jamezzTable.current?.refreshData();
        });
      },
    });
    actions.push({
      icon: Refresh,
      tooltip: <TranslationWrapper tKey={"Reset"} />,
      action: (row) => {
        Subscription.apiReset(row[0]).then(() => {
          jamezzTable.current?.refreshData();
        });
      },
    });
  }

  return (
    <div>
      <MainNavbar paginaTitel={<TranslationWrapper tDefault={"All licenses"} tKey={"licenses.title"} />} />
      <GridContainer>
        <GridItem>
          {filters?.venue_id?.value > 0 ? (
            <div>
              <Link to={"./create"}>
                <Button className={classes.marginRight} color={"success"}>
                  <Add className={classes.icons} />
                  <TranslationWrapper tKey={"New license"} />
                </Button>
              </Link>
            </div>
          ) : null}
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem md={4} xs={12}>
          <VenueFilter />
        </GridItem>
        <GridItem md={4} xs={12}>
          <DebtorFilter />
        </GridItem>
        <GridItem md={4} xs={12}>
          <ResellerFilter />
        </GridItem>
        <GridItem md={4} xs={12}>
          <Button
            onClick={() => {
              setFilter("venue_id", { field: "venue_id", operator: "=", value: null });
              setFilter("vestiging.venue_id", {
                field: "vestiging.venue_id",
                operator: "=",
                value: null,
              });
            }}
          >
            Filter on empty venue
          </Button>
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12}>
          <JamezzTable
            actions={actions}
            dataMapping={[
              { dbfield: "id", editable: false },
              {
                dbfield: "venue.name",
                editable: true,
                inputtype: "Link",
                urlData: { id: "venue.id" },
                url: "venues/:id/edit",
              },
              { dbfield: "venue.id", hide: true },
              new JamezzTableField("notes", false),
              {
                customData: (r) => r,
                customRender: (r) =>
                  r.end_date_unix == null || r.end_date_unix > r.next_date_unix
                    ? new Date(r.next_date_unix * 1000).toLocaleDateString()
                    : "-",
              },
              new JamezzTableDateField("end_date", false),
              {
                dbfield: "subs_debtor.company_name",
                editable: true,
                inputtype: "Link",
                urlData: { id: "subs_debtor.id" },
                url: "subsdebtors/:id/edit",
              },
              {
                dbfield: "subs_debtor.company_city",
                editable: false,
              },
              new JamezzTableLinkToRelation("subs_reseller.description", "subsresellers/:id/edit", {
                id: "subs_reseller.id",
              }),
              { dbfield: "subs_debtor.id", hide: true },
              { dbfield: "subs_reseller.id", hide: true },
            ]}
            delete={false}
            editLink={"./:id/edit"}
            editLinkPermission={"subssubscriptions/:id/edit"}
            fetchUrl={"core/subsSubscription"}
            filters={filters}
            headerIcon={<Restaurant />}
            headers={[
              {
                label: getTranslation("#", "#"),
                sortable: true,
                sortKey: "id",
              },
              {
                label: getTranslation("venue", "Venue"),
                sortable: true,
                sortKey: "venue_id",
              },
              {
                label: getTranslation("Notes"),
              },
              {
                label: getTranslation("Next invoice date"),
                sortable: true,
                sortKey: "next_date_unix",
              },
              {
                label: getTranslation("Final date of license"),
                sortable: true,
                sortKey: "end_date_unix",
              },
              {
                label: getTranslation("Debtor"),
                sortable: true,
                sortKey: "subs_debtor_id",
              },
              {
                label: getTranslation("City"),
              },
              {
                label: getTranslation("Reseller"),
                sortable: false,
              },
            ]}
            inputValues={{
              subs_debtors: subs_debtors,
              subs_resellers: subs_resellers,
              venues: venues,
            }}
            reduxKey={"subs_subscriptions"}
            ref={jamezzTable}
            tableTitle={<TranslationWrapper tDefault={"Licenses"} tKey={"licenses"} />}
          />
        </GridItem>
      </GridContainer>
    </div>
  );
};

export default withStyles(SubsSubscriptionsIndex, vestigingStyle);
